<template>
    <div v-if="paymentMethods && paymentMethods.boleto_bancario" class="pt-2">
        <p>
            Após realizar o pagamento do boleto, ele será confirmado pelo banco em até 3 dias úteis
            e seu pedido entrará em produção.
        </p>

        <div v-if="$scope.IS_WHOLESALER || $scope.IS_SALES_REP">
            <p>Opções de parcelamento:</p>

            <ul class="checkout-options">
                <li v-for="method in methods">
                    <input
                        :id="`billet-${method.total_installments}`"
                        v-model="selectedMethod"
                        :value="method"
                        class="cr-radio"
                        type="radio"
                    />
                    <label :for="`billet-${method.total_installments}`">
                        <p class="text-bold">
                            {{ method.label }}:
                            {{ $f.formatMoney(method.total) }}
                            <span v-if="method.discount > 0">
                                - {{ method.discount | number }}% de desconto</span
                            >
                        </p>
                        <template v-if="method.total_installments > 1">
                            <p v-if="method.equal_installments">
                                {{ method.total_installments }}x
                                {{ $f.formatMoney(method.installments[0]) }}
                            </p>
                            <template v-else>
                                <p>Parcelas:</p>
                                <ol>
                                    <li v-for="i of method.installments">
                                        {{ $f.formatMoney(i) }}
                                    </li>
                                </ol>
                            </template>
                        </template>
                        <p v-if="method.interests > 0">
                            Juros de {{ method.interests | number(2) }}% a.m.
                        </p>
                    </label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import CheckoutPaymentMethod from './CheckoutPaymentMethod';

    export default {
        extends: CheckoutPaymentMethod,

        name: 'CheckoutPaymentBoleto',

        props: ['cart', 'customer', 'paymentMethods'],

        data() {
            let methods = null;

            if (this.$scope.IS_WHOLESALER || this.$scope.IS_SALES_REP) {
                methods = this.paymentMethods.boleto_bancario.map((m) => {
                    const method = {
                        total: m.total,
                        discount: m.discount,
                        interests: m.interests,
                        installments: m.installments,
                        total_installments: m.total_installments,
                        equal_installments: m.installments.every((i) => i === m.installments[0]),
                    };

                    switch (m.total_installments) {
                        case 0:
                            method.label = 'À vista';
                            break;
                        case 1:
                            method.label = '1 parcela';
                            method.due = m.installmentDayStep + ' dias';
                            break;
                        case 2:
                            method.label = '2 parcelas';
                            method.due = '30 e 60 dias';
                            break;
                        case 3:
                            method.label = '3 parcelas';
                            method.due = '30, 60 e 90 dias';
                            break;
                        case 4:
                            method.label = '4 parcelas';
                            method.due = '30, 60, 90 e 120 dias';
                            break;
                    }

                    return method;
                });
            } else {
                methods = [
                    {
                        label: 'À vista',
                        total_installments: 1,
                    },
                ];
            }

            return {
                selectedMethod: methods[0],
                methods,
            };
        },

        computed: {
            description() {
                if (this.selectedMethod) {
                    return `Boleto Bancário - ${this.selectedMethod.label}`;
                } else {
                    return 'Boleto Bancário';
                }
            },
        },

        methods: {
            submit(callback) {
                callback({
                    module: 'boleto_bancario',
                    installments: this.selectedMethod.total_installments,
                });
            },
        },
    };
</script>
